<template>
    <div class="settlement-overall">
        <div class="content-box first">
            <template v-if="$store.state.userType == 3">
                <TitleTip v-if="income.bankPublicAccountFlag == 0">
                    你的账号升级为了企业后，还未更新收款账号，请先更新收款账号，否则无法完成提现打款；
                </TitleTip>
                <template v-else>
                    <TitleTip v-if="qualificationStatus == 0">
                        您的账号升级后，还未提交资质审核资料，故无法完成提现打款，
                        <el-link type="text" :href="$contractRouter('/manage/contract/enterprise/fdd/qualification', 'url')">提交资质资料</el-link>
                    </TitleTip>
                    <TitleTip v-if="qualificationStatus == 1">您提交的资料还在审核中，故无法完成提现打款；</TitleTip>
                </template>
            </template>
            <template v-else>
                <TitleTip v-if="income.accountFlag == 0">完善收款账号才能提现</TitleTip>
            </template>
            <TitleTip v-if="income.withdrawSwitch === 1">暂停提现，原因：{{ income.cpReason }}</TitleTip>
            <div class="overall-view">
                <div class="income">
                    <p>
                        可提现收益（版权收益￥{{ income.copyright.toLocaleString('zh', {minimumFractionDigits: 2}) }} + 邀请收益￥{{
                            income.invite.toLocaleString('zh', {minimumFractionDigits: 2})
                        }})
                    </p>
                    <div class="bd">
                        <Amount :value="income.total.toLocaleString('zh', {minimumFractionDigits: 2})"></Amount>
                        <el-button
                            v-if="$store.state.userType == 3 || withdrawType == 1"
                            @click="$router.push(`/manage/settlement/invoicing`)"
                            :disabled="enterpriseDisabled"
                            type="primary"
                        >
                            开票后提现
                        </el-button>
                        <el-button v-else :disabled="withdrawDisabled" :loading="withdrawLoading" @click="isWithdraw" type="primary">
                            {{ withdrawButtonText }}
                        </el-button>
                    </div>
                    <div class="ft">
                        <p>累计提现￥{{ income.withdrawTotalAmount }}</p>
                        <router-link v-if="income.accountFlag == 0" class="link underline" to="/manage/bankInfo">未绑卡，设置收款账号</router-link>
                        <span v-if="withdrawStatus == 2">有一笔提现交易进行中...</span>
                        <span v-if="withdrawStatus == 3">提现失败，工作人员处理中，不会造成损失...</span>
                    </div>
                </div>
                <div class="income">
                    <p>版权总收益</p>
                    <div class="bd">
                        <Amount :value="copyrightTotalAmount.toLocaleString('zh', {minimumFractionDigits: 2})"></Amount>
                    </div>
                    <div class="ft">
                        <p></p>
                        <router-link class="link underline" to="/manage/settlement/versionTax">查看明细</router-link>
                    </div>
                </div>
                <div class="income">
                    <p>邀请总收益</p>
                    <div class="bd">
                        <Amount :value="income.inviteTotalAmount.toLocaleString('zh', {minimumFractionDigits: 2})"></Amount>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-box m-t-4">
            <div class="title">收益和提现流水</div>
            <div class="page-list-box">
                <el-table v-loading="loading" :data="incomeList" style="width: 100%">
                    <el-table-column label="日期">
                        <template slot-scope="scope">
                            {{ $utils.formatDate(scope.row.addTime) }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status == 1">已</p>
                            <p v-if="scope.row.status == 2">提现中</p>
                            <p v-if="scope.row.status == 3">已取消</p>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="类型" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 1">邀请收益</span>
                            <span v-if="scope.row.type == 2 || scope.row.type == 6">版权收益</span>
                            <span v-if="scope.row.type == 3">提现</span>
                            <!-- <span v-if="scope.row.type == 5">分账通（我方）分出</span>
                            <span v-if="scope.row.type == 4">分账通（他人）分入</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="金额" align="right">
                        <template slot-scope="scope">
                            {{ `${scope.row.type == 3 || scope.row.type == 5 ? '-' : '+'} ${scope.row.amount} CNY` }}
                            <span class="status warning">{{ scope.row.status == 2 ? '(提现中)' : '' }}</span>
                            <span class="status danger">{{ scope.row.status == 3 ? '(已取消)' : '' }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="incomeList.length > 0" class="page-pagination-box">
                <el-pagination
                    background
                    @size-change="search"
                    @current-change="fetchIncome"
                    :current-page.sync="filterData.pageNo"
                    :page-size.sync="filterData.pageSize"
                    layout="prev, pager, next"
                    :total="totalCount || 0"
                ></el-pagination>
            </div>
        </div>
        <div class="content-box m-t-4 contract-box" v-if="contractInfo.length">
            <div class="title f-s">
                预付合同
                <span>具体抵扣详情，请前往版税收益明细中查看</span>
            </div>
            <div class="page-list-box">
                <el-table v-loading="loading" :data="contractInfo" style="width: 100%">
                    <el-table-column label="预付款合同" width="300px">
                        <template slot-scope="scope">
                            {{ scope.row.cpContractCode }}
                        </template>
                    </el-table-column>
                    <el-table-column label="抵扣方式" width="200px">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 2">先分成后抵扣</span>
                            <span v-else-if="scope.row.type == 3">先抵扣后分成</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="预付款总金额" align="right">
                        <template slot-scope="scope">
                            {{ `${scope.row.amount} CNY` }}
                        </template>
                    </el-table-column>
                    <el-table-column label="已抵扣金额" align="right">
                        <template slot-scope="scope">
                            {{ `${calculateDeducted(scope.row.amount, scope.row.balance)} CNY` }}
                        </template>
                    </el-table-column>
                    <el-table-column label="剩余抵扣金额（余额）" align="right" width>
                        <template slot-scope="scope">
                            {{ `${scope.row.balance} CNY` }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog title="确认提现" :visible.sync="dialogVisible" append-to-body width="400px" center>
            <div class="confirm-withdrawal">
                <p v-if="!withdrawLoading">确认提现后，系统将会转账 {{ income.total }} 元至您的支付宝账号中</p>
                <template v-else>
                    <i class="el-icon-loading"></i>
                    <b>等待提现完成</b>
                </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="withdrawLoading" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="withdrawLoading" @click="onWithdraw()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Big from 'big.js';
Big.DP = 2;

import {getQualification} from '@/api/user';

const defaultQuery = {
    cpId: '',
    pageNo: 1,
    pageSize: 10,
};
export default {
    data() {
        return {
            filterData: {...defaultQuery},
            tabsName: '1',
            loading: false,
            totalCount: 0,
            incomeList: [],
            withdrawStatus: null,
            withdrawDetail: [],
            withdrawLoading: false,
            dialogVisible: false,
            income: {
                total: 0,
                copyright: 0,
                invite: 0,
                inviteTotalAmount: 0,
                settlementTotalAmount: 0,
                dmhSettlementTotalAmount: 0,
                withdrawTotalAmount: 0,
            },
            qualificationStatus: null,
            withdrawType: 0, //提现方式，0 线上提现，1 线下提现
            contractInfo: [],
        };
    },
    computed: {
        withdrawButtonText() {
            if (this.income.total <= 0) return '暂不能提现';
            const {withdrawStatus} = this;
            if (withdrawStatus === 0) return '暂不能提现';
            if (withdrawStatus === 1) return '立即提现';
            if (withdrawStatus === 2) return '提现中';
            return '提现失败';
        },
        withdrawDisabled() {
            const {accountFlag, withdrawSwitch} = this.income;
            if (accountFlag === 0) return true;
            if (withdrawSwitch === 1) return true;
            if (this.income.total <= 0) return true;
            if (this.withdrawStatus == 1 && this.income.total > 0) return false;
            return true;
        },
        enterpriseDisabled() {
            const {bankPublicAccountFlag, withdrawSwitch} = this.income;
            if (this.income.total <= 0) return true;
            if (this.withdrawType === 1) return false; //线下提现
            if (withdrawSwitch === 1) return true;
            if (bankPublicAccountFlag == 1 && this.qualificationStatus == 2) return false;
            return true;
        },
        copyrightTotalAmount() {
            const {dmhSettlementTotalAmount, settlementTotalAmount} = this.income;
            const dmhAmount = Number(dmhSettlementTotalAmount) || 0;
            const settlementAmount = Number(settlementTotalAmount) || 0;
            return Big(dmhAmount).plus(settlementAmount).toNumber();
        },
    },
    created() {
        this.filterData.cpId = this.$store.state.userInfo.id;
        this.fetchStatistics();
        this.fetchIncome();
        this.fetchQualification();
        this.fetchContractInfo();
    },
    methods: {
        async isWithdraw() {
            const {isWithdraw} = this.$store.getters;
            // 企业用户不能进行提现操作
            if (this.$store.state.userType == 3) return this.$message.error('企业用户暂无法完成自动提现，请联系工作人员进行提现处理');
            // 企业升级中
            if (this.$store.getters.isEnterpriseUpgrade) return this.$message.error('您当前处于企业升级中，请升级完成后再购买发行服务');
            if (!isWithdraw) {
                const flag = await this.$confirm(`您还未完善收款 {支付宝|银行卡}，请先完善收款账号，否则无法完成提现打款`, '完善收款账号', {
                    confirmButtonText: '去完善',
                    cancelButtonText: '取消',
                }).catch(() => 'cancel');
                if (flag === 'cancel') return;
                this.$router.push('/manage/bankInfo');
            } else {
                if (this.income.total <= 0.1) return this.$message.error('提现金额不足0.1 元，无法转账，请等超过0.1元后再提现。');
                if (this.withdrawStatus == 1) return (this.dialogVisible = true);
            }
        },
        // 获取企业资质
        async fetchQualification() {
            const response = await getQualification();
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.qualificationStatus = result.status;
        },
        async fetchStatistics() {
            const response = await this.$request({
                url: '/cp-income/view/index',
                method: 'POST',
                data: {cpId: this.$store.state.userInfo.id},
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            let total = 0,
                copyright = 0,
                invite = 0;
            (result.withdrawDetail || []).forEach((row) => {
                total = Big(total).plus(row.amt).toNumber();
                if (row.type == 1) invite = Big(invite).plus(row.amt).toNumber();
                if ([2, 5].includes(row.type)) copyright = Big(copyright).plus(row.amt).toNumber();
            });
            this.withdrawStatus = result.withdrawStatus;
            this.withdrawDetail = result.withdrawDetail;
            this.withdrawType = result?.withdrawType || 0;
            this.income = {
                total,
                copyright,
                invite,
                ...result,
            };
        },
        async fetchIncome() {
            this.loading = true;
            const response = await this.$request({
                url: '/cp-income/view/list',
                method: 'POST',
                data: this.filterData,
                formData: false,
            });
            const {msg, state, result} = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '');
            this.incomeList = result.result;
            this.totalCount = result.totalCount;
        },
        // Fetch default
        search() {
            this.filterData.pageNo = 1;
            this.fetchIncome();
        },
        async onWithdraw() {
            this.withdrawLoading = true;
            const response = await this.$request({
                url: '/cp-income/up/withdraw',
                method: 'POST',
                data: {
                    cpId: this.$store.state.userInfo.id,
                    currency: 'CNY',
                    payType: 1,
                    withdrawDetail: this.withdrawDetail,
                },
                formData: false,
            });
            const {msg, state} = response.data;
            this.withdrawLoading = false;
            this.dialogVisible = false;
            if (!state) return this.$message.error(msg || '');
            this.$message.success('提现操作成功');
            this.fetchStatistics();
            this.fetchIncome();
        },
        //预付合同信息
        async fetchContractInfo() {
            this.loading = true;
            const response = await this.$request({
                url: 'cp-income/listSettlementInfo',
                params: {cpId: this.$store.state.userInfo.cpId},
            });
            const {msg, state, result} = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '');
            this.contractInfo = result || [];
        },
        formatAmount(value) {
            if (value === null || value === undefined) return '0';

            const num = Number(value);
            if (isNaN(num)) return '0';

            // 处理浮点数精度问题，然后去掉不必要的0
            const formatted = parseFloat(num.toFixed(10)).toString();
            return formatted;
        },

        // 计算已抵扣金额
        calculateDeducted(amount, balance) {
            if (amount === null || amount === undefined) return '0';
            if (balance === null || balance === undefined) return this.formatAmount(amount);

            // 使用 Big.js 确保计算精度
            const deducted = new Big(amount).minus(new Big(balance)).toNumber();
            return this.formatAmount(deducted);
        },
    },
};
</script>
<style lang="scss" scoped>
.settlement-overall {
    .contract-box {
        .f-s {
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            span {
                padding-left: 15px;
            }
        }
        ::v-deep .el-table {
            .el-table__body-wrapper {
                max-height: 200px;
                overflow-y: auto;
            }
        }
    }
}
.overall-view {
    display: flex;

    .income {
        background: linear-gradient(270deg, #fbfbfd 0%, #f5f6fa 100%);
        border-radius: 10px;
        width: 200px;
        padding: 50px 20px 30px;

        &:first-child {
            width: auto;
            flex: 1;
        }

        &:nth-child(2) {
            margin: 0 20px;
        }

        p {
            color: $-text-500;
        }

        .bd {
            margin: 14px 0 34px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 44px;
        }

        .ft {
            display: flex;
            justify-content: space-between;

            span {
                color: $-text-600;
            }
        }
    }
}

.confirm-withdrawal {
    text-align: center;

    b {
        margin-left: 8px;
    }
}
</style>
